import type { CurrentUser } from "./currentUserTypes";
import { can } from "./permissions";

export function getOperationalCapabilities(
  user: CurrentUser | null | undefined,
) {
  const isSuper = user?.role === "super";
  const isOverviewer = user?.role === "overviewer";

  return {
    canManageQuotation: isSuper || can(user, "quotation.manage"),
    canRemoveQuotationItem: isSuper || can(user, "quotation.remove_item"),
    canManageOrders: isSuper || can(user, "order.manage"),
    canManageCheckins:
      isSuper || user?.role === "checker" || can(user, "checkin.manage"),
    canManageCatalog:
      isSuper || isOverviewer || can(user, "catalog.manage"),
    canAudit: isSuper || isOverviewer || can(user, "audit.view"),
    canDelete: isSuper || isOverviewer || can(user, "destructive.manage"),
  };
}
